import Gallery from "pages/Restaurant/Gallery";

export default function GalleryPage() {
  return <Gallery />;
}
